import React from 'react';
import { founderNote } from '../../data/mock';
import { Quote } from 'lucide-react';
import { useScrollAnimation } from '../../hooks/use-scroll-animation';

export const AboutSection = () => {
  const [ref, isVisible] = useScrollAnimation({ threshold: 0.2 });

  return (
    <section className="py-32 lg:py-40 bg-gradient-to-b from-white to-slate-50/30 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-br from-amber-50/20 to-transparent rounded-full blur-3xl opacity-50 animate-pulse-slow" />
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div 
          ref={ref}
          className={`max-w-5xl mx-auto text-center transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {/* Premium Quote icon */}
          <div className="relative w-20 h-20 rounded-2xl bg-gradient-to-br from-slate-100 to-slate-50 flex items-center justify-center mx-auto mb-10 shadow-premium-lg group hover:scale-110 transition-transform duration-300">
            <Quote className="w-10 h-10 text-slate-600 group-hover:text-slate-900 transition-colors" />
            <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-amber-500/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          </div>
          
          {/* Premium Quote */}
          <blockquote className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 leading-tight mb-12 relative">
            <span className="absolute -top-4 -left-8 text-6xl text-amber-500/20 font-serif leading-none">"</span>
            <span className="relative z-10">{founderNote.quote}</span>
            <span className="absolute -bottom-8 -right-8 text-6xl text-amber-500/20 font-serif leading-none">"</span>
          </blockquote>
          
          {/* Premium Author */}
          <div className="flex items-center justify-center gap-5 mt-16">
            <div className="relative w-16 h-16 rounded-2xl bg-gradient-to-br from-slate-900 to-slate-800 flex items-center justify-center shadow-premium-lg group hover:scale-110 transition-transform duration-300">
              <span className="text-white font-bold text-lg tracking-tight">P</span>
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-amber-500/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </div>
            <div className="text-left">
              <p className="font-bold text-slate-900 text-lg">{founderNote.name}</p>
              <p className="text-sm text-slate-500 font-medium mt-1">Building the future, one product at a time</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
